import { render, staticRenderFns } from "./Carat.vue?vue&type=template&id=5937b8ab&scoped=true&"
import script from "./Carat.vue?vue&type=script&lang=ts&"
export * from "./Carat.vue?vue&type=script&lang=ts&"
import style0 from "./Carat.vue?vue&type=style&index=0&id=5937b8ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937b8ab",
  null
  
)

export default component.exports